export default __webpack_public_path__ + "static/media/parachute.740e2aef.svg";